// @TODO:-_- Quantity correspond with BC
export const COOKIE_EXPIRATION_TIME = 0.1667 // 4hour

// Basket metrics
export const DELIVERY_COURIER = 'novaposhta.courier'
export const DELIVERY_INTERNATIONAL = 'novaposhta.international'
export const DELIVERY_COD = 'cod'

